module.exports = __webpack_public_path__ + "static/media/closeButton.5af6f3e7.svg";